import { useQuery } from '@hooks/reactQuery';

import { previewConfigFile } from '@api/gNodeBConfigParameters';

import { IPreviewConfigFileDTO } from '@interfaces/crowdcell/dto/gNodeBConfigDTO';

import { PREVIEW_CONFIG_FILE } from '@constants/queryKeys';

export const useQueryPreviewConfigFile = (dto: IPreviewConfigFileDTO) => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<{ text: string }>({
		queryKey: [PREVIEW_CONFIG_FILE],
		queryFn: () => previewConfigFile(dto),
		refetchOnWindowFocus: false,
	});

	return {
		text: data?.text,
		isLoadingPreviewConfigFile: isLoading || isFetching,
	};
};
